export const SIZE_LG = 'lg';
export const SIZE_XL = 'xl';
export const SIZE_XS = 'xs';

export const WINDOW_SIZE = {
  windowSizesLarge: [SIZE_LG, SIZE_XL, 'xxl', 'xxxl'],
  windowSizesMedium: ['md'],
  windowSizesSmall: ['sm', SIZE_XS],
};
